/*
 * PNX #85 お客様専用注文ページの「商品追加・卸見積依頼」（snippets/pnx-b2b-item-request.liquid）
 *
 * - 対象は [data-pnx-item-request] の中だけ。注文一覧（data-order-list-id）は値を読むだけで、
 *   値・属性・イベントは変えない
 * - 送信は Shopify 標準の contact フォームのネイティブ POST。submit イベントは止めない
 *   （標準のスパム対策が submit を受けて自分で送信し直すため、止めても確認を素通りする）
 * - 入力チェック・未追加の注文入力の確認・二重押しの抑止は、送信ボタンの click の段階で行う
 *   （Enter による暗黙送信も、ブラウザが既定の送信ボタンへ click を送るので同じ経路を通る）
 * - 公開デモ（data-demo）には <form> が無い。確認までは動かし、最後は送信せずに案内だけ出す
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-pnx-item-request]';
  var RELEASE_MS = 15000;
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var TEXT = {
    required: 'を入力してください。',
    email: 'メールアドレスの形式をご確認ください（例：name@example.com）。',
    sending: '送信しています。画面が切り替わるまでお待ちください。',
    sendingButton: '送信しています…',
    demo: '公開デモのため送信していません。実際のお客様専用ページでは、この内容が担当者へメールで届きます。'
  };

  // 一覧で数量・購入単位を変えた行、または一括で選択中の行があるか（読み取りのみ）
  function hasUnsavedOrderInput(list) {
    if (!list) return false;
    if (list.querySelector('input.b2b-row-check:checked')) return true;

    var quantities = list.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < quantities.length; i++) {
      if (quantities[i].value !== quantities[i].defaultValue) return true;
    }

    var radios = list.querySelectorAll('input[type="radio"]');
    for (var j = 0; j < radios.length; j++) {
      if (radios[j].checked && !radios[j].defaultChecked) return true;
    }
    return false;
  }

  function fieldError(field) {
    var value = field.value.trim();
    if (field.required && !value) {
      return (field.getAttribute('data-pnx-ir-label') || 'この項目') + TEXT.required;
    }
    if (field.type === 'email' && value && !EMAIL_PATTERN.test(value)) return TEXT.email;
    return '';
  }

  function showFieldError(field, message) {
    var box = document.getElementById(field.id + '-error');
    if (message) {
      field.setAttribute('aria-invalid', 'true');
    } else {
      field.removeAttribute('aria-invalid');
    }
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  }

  function init(root) {
    if (root.getAttribute('data-pnx-ir-ready') === 'true') return;

    var form = root.querySelector('[data-pnx-ir-form]');
    var submit = root.querySelector('[data-pnx-ir-submit]');
    if (!form || !submit) return;
    root.setAttribute('data-pnx-ir-ready', 'true');

    var details = root.querySelector('[data-pnx-ir-details]');
    var confirmBox = root.querySelector('[data-pnx-ir-confirm]');
    var confirmMessage = root.querySelector('[data-pnx-ir-confirm-message]');
    var confirmBack = root.querySelector('[data-pnx-ir-confirm-back]');
    var confirmSend = root.querySelector('[data-pnx-ir-confirm-send]');
    var status = root.querySelector('[data-pnx-ir-status]');
    var result = root.querySelector('[data-pnx-ir-result]');
    var isDemo = root.hasAttribute('data-demo');
    var listId = root.getAttribute('data-order-list-id');
    var submitLabel = submit.textContent;
    var confirmed = false;
    var submitting = false;
    var releaseTimer = null;

    function setStatus(text) {
      if (status) status.textContent = text;
    }

    function validate() {
      var fields = form.querySelectorAll('[data-pnx-ir-field]');
      var firstInvalid = null;
      for (var i = 0; i < fields.length; i++) {
        var message = fieldError(fields[i]);
        showFieldError(fields[i], message);
        if (message && !firstInvalid) firstInvalid = fields[i];
      }
      if (firstInvalid) firstInvalid.focus();
      return !firstInvalid;
    }

    function openConfirm() {
      if (!confirmBox) return;
      confirmBox.hidden = false;
      if (confirmMessage) confirmMessage.focus();
    }

    function closeConfirm() {
      if (confirmBox) confirmBox.hidden = true;
    }

    function release() {
      submitting = false;
      clearTimeout(releaseTimer);
      submit.removeAttribute('aria-disabled');
      submit.textContent = submitLabel;
      setStatus('');
    }

    function markSubmitting() {
      submitting = true;
      submit.setAttribute('aria-disabled', 'true');
      submit.textContent = TEXT.sendingButton;
      setStatus(TEXT.sending);
      clearTimeout(releaseTimer);
      // 送信が画面遷移に至らなかった場合（確認画面を閉じた等）に備えて、一定時間で押せる状態へ戻す。
      // 自動では再送しない
      releaseTimer = setTimeout(release, RELEASE_MS);
    }

    submit.addEventListener('click', function (event) {
      if (submitting) {
        event.preventDefault();
        return;
      }
      setStatus('');

      if (!validate()) {
        event.preventDefault();
        confirmed = false;
        return;
      }

      if (!confirmed && hasUnsavedOrderInput(document.getElementById(listId))) {
        event.preventDefault();
        openConfirm();
        return;
      }

      confirmed = false;
      closeConfirm();

      if (isDemo) {
        event.preventDefault();
        setStatus(TEXT.demo);
      }
      // 実顧客ページではここで止めない（ネイティブ送信 → Shopify 標準の submit 処理へ）
    });

    if (!isDemo) {
      // 送信は止めない。二重押しの目印だけ付ける
      form.addEventListener('submit', function (event) {
        if (event.target === form) markSubmitting();
      });
    }

    if (confirmBack) {
      confirmBack.addEventListener('click', function () {
        confirmed = false;
        closeConfirm();
        submit.focus();
      });
    }

    if (confirmSend) {
      confirmSend.addEventListener('click', function () {
        confirmed = true;
        closeConfirm();
        submit.click();
      });
    }

    form.addEventListener('input', function (event) {
      var field = event.target;
      if (!field || !field.hasAttribute || !field.hasAttribute('data-pnx-ir-field')) return;
      if (field.getAttribute('aria-invalid') === 'true') showFieldError(field, fieldError(field));
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) release();
    });

    if (result) {
      if (details) details.open = true;
      result.focus();
    }
  }

  function initAll(scope) {
    var roots = scope.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // テーマエディタでセクションを再描画したとき
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) initAll(event.target);
  });
})();
